import React from 'react';
import dialogMinStyle from '../../styles/organisms/dialog-min.scss';

export const ConfirmDialog = props => (
  <div
    className={`${dialogMinStyle['dialog-min']} dialog--modal`}
    onClick={e => {
      e.stopPropagation();
    }}
  >
    <div className='dialog-min__body text-center'>{props.dialog.message}</div>
    <div className='dialog-min__footer'>
      <button
        className='btn--small--sub'
        onClick={e => props.dialog.callback.confirm(e)}
      >
        確認
      </button>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/modals/ConfirmDialog.jsx